import React from "react";

const Confidentialite = () => (
  <div className="legal-page">
    <h2>Politique de Confidentialité</h2>
    <p>Voici notre politique de confidentialité...</p>
  </div>
);

export default Confidentialite;
